import {getConfigFields} from '../fields.js'
import {formFieldIds} from '../values.js'

const {adTitle, comments, hidePhone, price} = formFieldIds

export const formPublishAdClassicBikeFormConfig = {
  fields: [
    getConfigFields[adTitle](),
    getConfigFields[price]({
      customProps: {
        help: 'PUBLISH_AD.FB.PRIZES.HELP',
        hint: 'PUBLISH_AD.FB.PRIZES.HINT'
      }
    })
  ],
  initialValues: {
    [adTitle]: '',
    [comments]: '',
    [hidePhone]: true,
    [price]: ''
  },
  lockedFieldsOnEdition: [adTitle],
  remotes: [],
  rules: {}
}
